import { api } from '@/redux/api';
import { RootState } from '@/redux/store';
import { Group } from '@/types/group';
import { findById } from '@/utils/find-by-id';

export const selectGroupsById =
  (groupIds: number[], organisationId: number) =>
  (state: RootState): Group[] => {
    const { data: orgGroups } = api.endpoints.getGroups.select({
      organisationId: organisationId,
    })(state);
    const { data: allGroups } = api.endpoints.getAllGroups.select()(state);
    const groups = orgGroups ?? allGroups;
    const results: Group[] = [];
    for (const groupId of groupIds ?? []) {
      results.push(
        findById(groups ?? [], groupId) ?? {
          id: groupId,
          groupName: 'Unknown',
          organisation: { id: -1, name: 'Unknown', active: false },
          createdAt: '',
          updatedAt: '',
        },
      );
    }
    return results;
  };
